import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap} from "rxjs/operators";
import * as fromStreetGql from "./street.graphql";
import {BaseResponse} from "../../../../../common/interfaces/global-interfaces";
import {GraphqlService} from "../../../../../services/graphql.service";
import {StreetActions} from "./street.actions";
import {Street} from "./street.model";


@Injectable()
export class StreetEffects {

  loadData$ = createEffect(() => this.actions$.pipe(
    ofType(StreetActions.getAllStreetsByWard),
    switchMap((action) => this.apollo.queryObservable({
        query: fromStreetGql.ALL_STREETS_BY_WARD,
        variables: {wardUniqueId: action.wardUniqueId}
      })
    ),
    switchMap((response: any) => {
      const result: BaseResponse<Street[]> = Object.values(Object.values(response)[0])[0];
      if (result?.response?.status) {
        return [
          StreetActions.loadStreets({streets: result?.data || []}),
          StreetActions.streetsLoadingState({loading: false})
        ]
      } else {
        return [StreetActions.streetsLoadingState({loading: false})]
      }
    })
  ));

  constructor(
    private actions$: Actions,
    private apollo: GraphqlService,
  ) {
  }

}
